var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 8.5L16 9.7L9.2 16.5L8 15.3L14.8 8.5ZM4 4.5H20C21.11 4.5 22 5.39 22 6.5V10.5C21.4696 10.5 20.9609 10.7107 20.5858 11.0858C20.2107 11.4609 20 11.9696 20 12.5C20 13.0304 20.2107 13.5391 20.5858 13.9142C20.9609 14.2893 21.4696 14.5 22 14.5V18.5C22 19.61 21.11 20.5 20 20.5H4C3.46957 20.5 2.96086 20.2893 2.58579 19.9142C2.21071 19.5391 2 19.0304 2 18.5V14.5C3.11 14.5 4 13.61 4 12.5C4 11.9696 3.78929 11.4609 3.41421 11.0858C3.03914 10.7107 2.53043 10.5 2 10.5V6.5C2 5.96957 2.21071 5.46086 2.58579 5.08579C2.96086 4.71071 3.46957 4.5 4 4.5ZM4 6.5V9.04C4.60768 9.3904 5.11236 9.89466 5.46325 10.5021C5.81415 11.1094 5.9989 11.7985 5.9989 12.5C5.9989 13.2015 5.81415 13.8906 5.46325 14.4979C5.11236 15.1053 4.60768 15.6096 4 15.96V18.5H20V15.96C19.3923 15.6096 18.8876 15.1053 18.5367 14.4979C18.1858 13.8906 18.0011 13.2015 18.0011 12.5C18.0011 11.7985 18.1858 11.1094 18.5367 10.5021C18.8876 9.89466 19.3923 9.3904 20 9.04V6.5H4ZM9.5 8.5C10.33 8.5 11 9.17 11 10C11 10.83 10.33 11.5 9.5 11.5C8.67 11.5 8 10.83 8 10C8 9.17 8.67 8.5 9.5 8.5ZM14.5 13.5C15.33 13.5 16 14.17 16 15C16 15.83 15.33 16.5 14.5 16.5C13.67 16.5 13 15.83 13 15C13 14.17 13.67 13.5 14.5 13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponOutline);
export default __webpack_public_path__ + "static/media/coupon-outline.59e7c73036b8859bfb4380c355226b83.svg";
export { ForwardRef as ReactComponent };